import { type AxiosInstance } from 'axios'

type userCredentials = {
  email: string
  password: string
}

interface RegisterData {
  email: string
  first_name: string
  last_name: string
  password1: string
  company: number
}

export default (axios: AxiosInstance, store) => ({
  login({ email, password }: userCredentials) {
    return axios.post('/v1/auth/login/', {
      email,
      password,
    })
  },
  register(data: RegisterData) {
    return axios.post('/v1/register/', data)
  },
  refreshTokens(refresh: string) {
    return axios.post('/v1/auth/token/refresh/', { refresh })
  },
  fetchUser() {
    return axios.get('/v1/auth/user/')
  },
  passwordReset(email: string) {
    return axios.post('/v1/auth/password/reset/', { email })
  },
  async logout() {
    await axios.post('/v1/auth/logout/')
    store.auth.logout()
  },
})
